import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import "../styles/comments.css";

function PostComments() {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [name, setName] = useState("");
  const [isWasher, setIsWasher] = useState(false);
  const { postId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const commentsRef = collection(db, "comments");
    const q = query(
      commentsRef,
      where("postId", "==", postId),
      orderBy("timestamp", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const commentsArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        timestamp: doc.data().timestamp?.toDate().toLocaleString(),
      }));
      setComments(commentsArray);
      console.log(commentsArray);
    });

    return () => unsubscribe(); // Detach listener on unmount
  }, [postId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const displayName = isWasher ? `${name} -washer` : name;

    try {
      const docRef = await addDoc(collection(db, "comments"), {
        text: newComment,
        name: displayName,
        postId: postId,
        timestamp: serverTimestamp(),
      });

      setNewComment("");
      setName("");
      setIsWasher(false);
    } catch (error) {
      console.error("Error adding comment: ", error);
    }
  };

  return (
    <div className="siteWrapper">
      <div className="comments-parent-container">
        <div className="comments-section">
          <h2>Comments</h2>
          <div className="comments-container">
            {comments.map((comment) => (
              <div key={comment.id} className="comment-card">
                <p>
                  <strong>{comment.name}</strong>: {comment.text}
                </p>
                <span>{comment.timestamp}</span>
              </div>
            ))}
          </div>
          <form onSubmit={handleSubmit} className="comment-form">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="comment-name-input"
              placeholder="Your name"
              required
            />

            <textarea
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              className="comment-textarea"
              placeholder="Write a comment..."
              required
            ></textarea>
            <button type="submit" className="submit-comment-button">
              Post Comment
            </button>
          </form>
          <button onClick={() => navigate(-1)} className="back-to-posts-button">
            Back to posts
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostComments;
